import { render, staticRenderFns } from "./ProjectRequested.vue?vue&type=template&id=8d54ed82&"
import script from "./ProjectRequested.vue?vue&type=script&lang=js&"
export * from "./ProjectRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports